import { useGetReceptionDevice } from '@reception-web/common/api/www'
import { useTranslation } from 'react-i18next'

import { useDeviceIdProvider } from '../../../hooks'
import { Text } from '../../basics'

export function Header() {
  const { i18n } = useTranslation()
  const ja = i18n.getFixedT('ja', 'translation', 'components.Header')
  const en = i18n.getFixedT('en', 'translation', 'components.Header')
  const { deviceId } = useDeviceIdProvider()
  const { data: receptionDevice } = useGetReceptionDevice(deviceId ?? '')

  if (!receptionDevice) {
    return null
  }

  return (
    <Text weight="bold" size="heading1" align="center">
      {ja('title', {
        property: receptionDevice?.data?.property_translations?.ja?.name,
      })}
      <br />
      {en('title', {
        property: receptionDevice?.data?.property_translations?.en?.name,
      })}
    </Text>
  )
}
